module.exports = __webpack_public_path__ + "img/fm-io.2b7257e2.svg";